<template>
<div>
	<div class="title">发票信息
		<RadioGroup v-model="form.invoiceType" class="ml15" @on-change="getInputInfo">
	        <Radio label="3" :disabled="disabled">普票（电子）</Radio>
	        <Radio label="2" :disabled="disabled">专票（纸质）</Radio>
	        <Radio label="1" :disabled="disabled">不开发票</Radio>
	    </RadioGroup>
	</div>
	<Form :model="form" :label-width="150" class="mt15" ref="invoice" :rules="invoiceValidate" v-if="form.invoiceType!='1'">
	    <FormItem label="公司名称" class="w600" prop="invoiceName">
	        {{form.invoiceName}}
	    </FormItem>
	    <FormItem label="统一社会信用代码" class="w600" prop="invoiceFaxNo">
	        {{form.invoiceFaxNo}}
	    </FormItem>
	    <FormItem label="开户地址" class="w600" prop="invoiceAddress">
	        <Input v-model="form.invoiceAddress" placeholder="请输入开票地址" :maxlength="50"></Input>
	    </FormItem>
	    <FormItem label="联系电话" class="w600" prop="invoicePhone">
	        <Input v-model="form.invoicePhone" placeholder="请输入开票电话" :maxlength="20"></Input>
	    </FormItem>
	    <FormItem label="开户行" class="w600" prop="invoiceBank">
	        <Input v-model="form.invoiceBank" placeholder="请输入开户行" :maxlength="30"></Input>
	    </FormItem>
	    <FormItem label="对公账号" class="w600" prop="invoiceAccount">
	        <Input v-model.trim="form.invoiceAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
	    </FormItem>
	    <FormItem label="电子邮箱" class="w600" prop="email">
	        <Input v-model="form.email" placeholder="请输入电子邮箱" :maxlength="100"></Input>
	    </FormItem>
	    <FormItem label="邮寄地址" class="w600" prop="postAddress">
	        <Input v-model="form.postAddress" placeholder="请输入邮寄地址" :maxlength="100"></Input>
	    </FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
	data () {
		return {
			form:{},
			invoiceValidate:{
				invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
				invoiceFaxNo:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
				invoiceAddress:{required:true,message:'请输入开票地址',trigger:'blur'},
				invoicePhone:{required:true,message:'请输入开票电话',trigger:'blur'},
				invoiceBank:{required:true,message:'请输入开户行',trigger:'blur'},
				invoiceAccount:{required:true,message:'请输入正确的对公账号',trigger:'blur'},
				email:{required:true,message:'邮箱格式错误',trigger:'blur',pattern:this.rules.email},
				postAddress:{required:true,message:'请输入对公账号',trigger:'blur'}
			}
		}
	},
	computed:{
		disabled(){
			return !this.form.invoiceName||!this.form.invoiceFaxNo
		}
	},
	watch:{
		info (val) {
			this.form=val;
			this.form.invoiceName=val.companyName||val.invoiceName||'';
			this.form.invoiceFaxNo=val.organizationCode||val.invoiceFaxNo||'';
		},
	},
	created(){
		this.form=this.info
	},
	methods:{
		val () {
			return new Promise((resolve,reject)=>{
				if(this.form.invoiceType=='1'){
					resolve({
						invoiceType:'1'
					})
					return;
				}
				this.$refs.invoice.validate(valid=>{
					resolve(valid?this.form:false)
				})
			})
		},
		/*获取用户输入的信息*/
		getInputInfo (value) {
			if(value=='1')return;
			this.$set(this.form,'invoiceAddress',this.form.invoiceAddress || this.form.address)
			this.$set(this.form,'invoicePhone',this.form.invoicePhone || this.form.contactsPhone)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/common/Invoice.vue